import 'tailwindcss/tailwind.css'; // If we end up using this elsewhere, we may want to import this in global.less

import AccountAddressService from 'JS/services/AccountAddressService';
import Icon from 'JS/components/Icon.vue';
import SchedulerApp from './components/SchedulerApp.vue';
import Vue, { defineComponent, onMounted, provide } from 'vue';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { provideServices } from './services';
import { useDocumentVisibilityChange } from 'JS/composables/document-visibility';
import { useOrderStore } from './state/order';

const pinia = createPinia();

Vue.use(PiniaVuePlugin);

new Vue({
	el: '#schedulerApp',
	pinia,
	render: h => h(defineComponent({
		render: h => h(SchedulerApp),
		setup() {
			provideServices();
			provide('AccountAddressService', new AccountAddressService());

			const orderStore = useOrderStore();

			// Refresh session when tab comes back to foreground
			useDocumentVisibilityChange(visible => {
				if (visible) {
					orderStore.fetchSession();
				}
			});

			onMounted(() => {
				orderStore.fetchSession();
			});
		},
	})),
});